"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useActivities", {
  enumerable: true,
  get: function get() {
    return _useActivities.default;
  }
});
Object.defineProperty(exports, "useAvatarForBot", {
  enumerable: true,
  get: function get() {
    return _useAvatarForBot.default;
  }
});
Object.defineProperty(exports, "useAvatarForUser", {
  enumerable: true,
  get: function get() {
    return _useAvatarForUser.default;
  }
});
Object.defineProperty(exports, "useConnectivityStatus", {
  enumerable: true,
  get: function get() {
    return _useConnectivityStatus.default;
  }
});
Object.defineProperty(exports, "useDictateInterims", {
  enumerable: true,
  get: function get() {
    return _useDictateInterims.default;
  }
});
Object.defineProperty(exports, "useDictateState", {
  enumerable: true,
  get: function get() {
    return _useDictateState.default;
  }
});
Object.defineProperty(exports, "useDisabled", {
  enumerable: true,
  get: function get() {
    return _useDisabled.default;
  }
});
Object.defineProperty(exports, "useEmitTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _useEmitTypingIndicator.default;
  }
});
Object.defineProperty(exports, "useFocusSendBox", {
  enumerable: true,
  get: function get() {
    return _useFocusSendBox.default;
  }
});
Object.defineProperty(exports, "useGrammars", {
  enumerable: true,
  get: function get() {
    return _useGrammars.default;
  }
});
Object.defineProperty(exports, "useGroupTimestamp", {
  enumerable: true,
  get: function get() {
    return _useGroupTimestamp.default;
  }
});
Object.defineProperty(exports, "useLanguage", {
  enumerable: true,
  get: function get() {
    return _useLanguage.default;
  }
});
Object.defineProperty(exports, "useLastTypingAt", {
  enumerable: true,
  get: function get() {
    return _useLastTypingAt.default;
  }
});
Object.defineProperty(exports, "useLocalize", {
  enumerable: true,
  get: function get() {
    return _useLocalize.default;
  }
});
Object.defineProperty(exports, "useLocalizeDate", {
  enumerable: true,
  get: function get() {
    return _useLocalizeDate.default;
  }
});
Object.defineProperty(exports, "useMarkActivityAsSpoken", {
  enumerable: true,
  get: function get() {
    return _useMarkActivityAsSpoken.default;
  }
});
Object.defineProperty(exports, "usePerformCardAction", {
  enumerable: true,
  get: function get() {
    return _usePerformCardAction.default;
  }
});
Object.defineProperty(exports, "usePostActivity", {
  enumerable: true,
  get: function get() {
    return _usePostActivity.default;
  }
});
Object.defineProperty(exports, "useReferenceGrammarID", {
  enumerable: true,
  get: function get() {
    return _useReferenceGrammarID.default;
  }
});
Object.defineProperty(exports, "useRenderActivity", {
  enumerable: true,
  get: function get() {
    return _useRenderActivity.default;
  }
});
Object.defineProperty(exports, "useRenderAttachment", {
  enumerable: true,
  get: function get() {
    return _useRenderAttachment.default;
  }
});
Object.defineProperty(exports, "useRenderMarkdownAsHTML", {
  enumerable: true,
  get: function get() {
    return _useRenderMarkdownAsHTML.default;
  }
});
Object.defineProperty(exports, "useScrollToEnd", {
  enumerable: true,
  get: function get() {
    return _useScrollToEnd.default;
  }
});
Object.defineProperty(exports, "useSendBoxValue", {
  enumerable: true,
  get: function get() {
    return _useSendBoxValue.default;
  }
});
Object.defineProperty(exports, "useSendEvent", {
  enumerable: true,
  get: function get() {
    return _useSendEvent.default;
  }
});
Object.defineProperty(exports, "useSendFiles", {
  enumerable: true,
  get: function get() {
    return _useSendFiles.default;
  }
});
Object.defineProperty(exports, "useSendMessage", {
  enumerable: true,
  get: function get() {
    return _useSendMessage.default;
  }
});
Object.defineProperty(exports, "useSendMessageBack", {
  enumerable: true,
  get: function get() {
    return _useSendMessageBack.default;
  }
});
Object.defineProperty(exports, "useSendPostBack", {
  enumerable: true,
  get: function get() {
    return _useSendPostBack.default;
  }
});
Object.defineProperty(exports, "useSendTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _useSendTypingIndicator.default;
  }
});
Object.defineProperty(exports, "useShouldSpeakIncomingActivity", {
  enumerable: true,
  get: function get() {
    return _useShouldSpeakIncomingActivity.default;
  }
});
Object.defineProperty(exports, "useStartDictate", {
  enumerable: true,
  get: function get() {
    return _useStartDictate.default;
  }
});
Object.defineProperty(exports, "useStopDictate", {
  enumerable: true,
  get: function get() {
    return _useStopDictate.default;
  }
});
Object.defineProperty(exports, "useStyleOptions", {
  enumerable: true,
  get: function get() {
    return _useStyleOptions.default;
  }
});
Object.defineProperty(exports, "useStyleSet", {
  enumerable: true,
  get: function get() {
    return _useStyleSet.default;
  }
});
Object.defineProperty(exports, "useSubmitSendBox", {
  enumerable: true,
  get: function get() {
    return _useSubmitSendBox.default;
  }
});
Object.defineProperty(exports, "useSuggestedActions", {
  enumerable: true,
  get: function get() {
    return _useSuggestedActions.default;
  }
});
Object.defineProperty(exports, "useTimeoutForSend", {
  enumerable: true,
  get: function get() {
    return _useTimeoutForSend.default;
  }
});
Object.defineProperty(exports, "useUserID", {
  enumerable: true,
  get: function get() {
    return _useUserID.default;
  }
});
Object.defineProperty(exports, "useUsername", {
  enumerable: true,
  get: function get() {
    return _useUsername.default;
  }
});
Object.defineProperty(exports, "useVoiceSelector", {
  enumerable: true,
  get: function get() {
    return _useVoiceSelector.default;
  }
});
Object.defineProperty(exports, "useWebSpeechPonyfill", {
  enumerable: true,
  get: function get() {
    return _useWebSpeechPonyfill.default;
  }
});
Object.defineProperty(exports, "useMicrophoneButtonClick", {
  enumerable: true,
  get: function get() {
    return _MicrophoneButton.useMicrophoneButtonClick;
  }
});
Object.defineProperty(exports, "useMicrophoneButtonDisabled", {
  enumerable: true,
  get: function get() {
    return _MicrophoneButton.useMicrophoneButtonDisabled;
  }
});
Object.defineProperty(exports, "useSendBoxSpeechInterimsVisible", {
  enumerable: true,
  get: function get() {
    return _BasicSendBox.useSendBoxSpeechInterimsVisible;
  }
});
Object.defineProperty(exports, "useTextBoxSubmit", {
  enumerable: true,
  get: function get() {
    return _TextBox.useTextBoxSubmit;
  }
});
Object.defineProperty(exports, "useTextBoxValue", {
  enumerable: true,
  get: function get() {
    return _TextBox.useTextBoxValue;
  }
});
Object.defineProperty(exports, "useTypingIndicatorVisible", {
  enumerable: true,
  get: function get() {
    return _TypingIndicator.useTypingIndicatorVisible;
  }
});

var _useActivities = _interopRequireDefault(require("./useActivities"));

var _useAvatarForBot = _interopRequireDefault(require("./useAvatarForBot"));

var _useAvatarForUser = _interopRequireDefault(require("./useAvatarForUser"));

var _useConnectivityStatus = _interopRequireDefault(require("./useConnectivityStatus"));

var _useDictateInterims = _interopRequireDefault(require("./useDictateInterims"));

var _useDictateState = _interopRequireDefault(require("./useDictateState"));

var _useDisabled = _interopRequireDefault(require("./useDisabled"));

var _useEmitTypingIndicator = _interopRequireDefault(require("./useEmitTypingIndicator"));

var _useFocusSendBox = _interopRequireDefault(require("./useFocusSendBox"));

var _useGrammars = _interopRequireDefault(require("./useGrammars"));

var _useGroupTimestamp = _interopRequireDefault(require("./useGroupTimestamp"));

var _useLanguage = _interopRequireDefault(require("./useLanguage"));

var _useLastTypingAt = _interopRequireDefault(require("./useLastTypingAt"));

var _useLocalize = _interopRequireDefault(require("./useLocalize"));

var _useLocalizeDate = _interopRequireDefault(require("./useLocalizeDate"));

var _useMarkActivityAsSpoken = _interopRequireDefault(require("./useMarkActivityAsSpoken"));

var _usePerformCardAction = _interopRequireDefault(require("./usePerformCardAction"));

var _usePostActivity = _interopRequireDefault(require("./usePostActivity"));

var _useReferenceGrammarID = _interopRequireDefault(require("./useReferenceGrammarID"));

var _useRenderActivity = _interopRequireDefault(require("./useRenderActivity"));

var _useRenderAttachment = _interopRequireDefault(require("./useRenderAttachment"));

var _useRenderMarkdownAsHTML = _interopRequireDefault(require("./useRenderMarkdownAsHTML"));

var _useScrollToEnd = _interopRequireDefault(require("./useScrollToEnd"));

var _useSendBoxValue = _interopRequireDefault(require("./useSendBoxValue"));

var _useSendEvent = _interopRequireDefault(require("./useSendEvent"));

var _useSendFiles = _interopRequireDefault(require("./useSendFiles"));

var _useSendMessage = _interopRequireDefault(require("./useSendMessage"));

var _useSendMessageBack = _interopRequireDefault(require("./useSendMessageBack"));

var _useSendPostBack = _interopRequireDefault(require("./useSendPostBack"));

var _useSendTypingIndicator = _interopRequireDefault(require("./useSendTypingIndicator"));

var _useShouldSpeakIncomingActivity = _interopRequireDefault(require("./useShouldSpeakIncomingActivity"));

var _useStartDictate = _interopRequireDefault(require("./useStartDictate"));

var _useStopDictate = _interopRequireDefault(require("./useStopDictate"));

var _useStyleOptions = _interopRequireDefault(require("./useStyleOptions"));

var _useStyleSet = _interopRequireDefault(require("./useStyleSet"));

var _useSubmitSendBox = _interopRequireDefault(require("./useSubmitSendBox"));

var _useSuggestedActions = _interopRequireDefault(require("./useSuggestedActions"));

var _useTimeoutForSend = _interopRequireDefault(require("./useTimeoutForSend"));

var _useUserID = _interopRequireDefault(require("./useUserID"));

var _useUsername = _interopRequireDefault(require("./useUsername"));

var _useVoiceSelector = _interopRequireDefault(require("./useVoiceSelector"));

var _useWebSpeechPonyfill = _interopRequireDefault(require("./useWebSpeechPonyfill"));

var _MicrophoneButton = require("../SendBox/MicrophoneButton");

var _BasicSendBox = require("../BasicSendBox");

var _TextBox = require("../SendBox/TextBox");

var _TypingIndicator = require("../SendBox/TypingIndicator");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}